import React from 'react';

import Badge from '@atlaskit/badge/badge';

const BadgeAddedExample = (): React.JSX.Element => {
	return <Badge appearance="added">+100</Badge>;
};

export default BadgeAddedExample;
